// src/pages/PrivacyPolicy.tsx
import React from "react";

const PrivacyPolicy: React.FC = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Privacy Policy</h1>

      <p style={styles.text}>
        This app uses the device camera only for scanning QR codes.
      </p>

      <p style={styles.text}>
        No photos or videos are stored, shared, or uploaded to any server.
      </p>

      <p style={styles.text}>
        No personal data is collected or shared with third parties.
      </p>

      <p style={styles.contact}>
        If you have questions, contact:{" "}
        <a href="mailto:support@yourdomain.com">
          support@yourdomain.com
        </a>
      </p>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    maxWidth: 800,
    margin: "40px auto",
    padding: "0 20px",
    fontFamily: "Arial, sans-serif",
    color: "#333",
  },
  title: {
    fontSize: "28px",
    marginBottom: "20px",
  },
  text: {
    fontSize: "16px",
    lineHeight: 1.6,
    marginBottom: "12px",
  },
  contact: {
    fontSize: "16px",
    marginTop: "20px",
  },
};

export default PrivacyPolicy;
